Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
function raiseError() {
    throw new Error(Array.prototype.join.call(arguments, constants_1.SPACE));
}
exports.raiseError = raiseError;
